export default function SingleItemSkeleton () {
  return (
    <div className="flex items-center justify-between animate-pulse">
      <div className="w-14 h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 mr-3" />
      <div className="w-16 h-2 bg-gray-200 rounded-full dark:bg-gray-700" />
    </div>
  )
}
